export default __webpack_public_path__ + "static/seguro_social_costa_rica-dff579f1e8ed204b1b3272783d10973b.webp";